import { bl_fi_cash_document_import_file_hdr_RowClass } from '../../../dbschema';
import { BaseContainerModel } from '../../base-container.model';

export class CashDocumentImportFileHdrContainer extends BaseContainerModel {
    bl_fi_cash_document_import_file_hdr: bl_fi_cash_document_import_file_hdr_RowClass = new bl_fi_cash_document_import_file_hdr_RowClass();
}